<template>
  <div class="activity519" id="activity519">
    <AppHeader/>
  	<div class="top-banner"></div>
    <div class="body-content">
      <div class="ctn-box">
        <div class="panel-box">
          <div class="c-box">
            <div class="title-box t1">
              大智慧365+大智慧APP沪深LEVEL-2手机版
            </div>
            <div class="tlebtm-bigfont">
              <span>限时优惠</span>
            </div>
            <div class="tle-tip">
              大智慧365是界面简洁，简单好用的炒股利器，助你轻松选股操作。沪深level-2、全息盘口等核心功能直击主力买卖，为您提供多种特色数据服务！软件轻量化，价格亲民化。
            </div>
            <div class=" price-box formula-box">
              <div class="clearfix">
                <span class="p-item">
                  <p class="tle-box">大智慧365</p>
                  <p class="p-box">998/年</p>
                </span>
                <em class="symbol-box">+</em>
                <span class="p-item">
                  <p class="tle-box">沪深LEVEL-2手机版</p>
                  <p class="p-box">58/年</p>
                </span>
                <em class="symbol-box">=</em>
                <span class="p-item">
                  <p class="tle-box">PC+沪深L2手机版</p>
                  <p class="p-box"><span class="p-em">只需</span>998/年</p>
                </span>
              </div>
              <div class="btn-box">
                <div class="buy-btn" @click="goUrl(3047)">
                  立即购买
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="panel-box">
          <div class="c-box">
            <div class="title-box  t2">
              策略投资终端+题材王（手机版）
            </div>
            <div class="tle-tip">
              大智慧策略投资终端是专为高级投资者和专业机构所设计的高端金融信息服务产品，综合运用多维一体的资金分析模型、智能大数据分析系统、精选系统策略，创造投资新高度。
            </div>
            <div class=" price-box tw-box">
              <div class="clearfix tw-item">
                <span class="p-item">
                  <p class="tle-box">策略投资终端1年+题材王1年</p>
                  <p class="p-box">41000元</p>
                </span>
                <div class="btn-box">
                  <div class="buy-btn" @click="goUrl(3053)">
                    立即购买
                  </div>
                </div>
              </div>
              <div class="clearfix tw-item">
                <span class="p-item">
                  <p class="tle-box">策略投资终端1年+题材王1季度</p>
                  <p class="p-box">38000元</p>
                </span>
                <div class="btn-box">
                  <div class="buy-btn" @click="goUrl(3052)">
                    立即购买
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="panel-box">
          <div class="c-box">
            <div class="title-black">
              <p>题材王（手机版）3大特色助你紧跟题材方向，挖掘产业价值</p>
              <p>
                免费领题材王产业印刷手册（印刷频次视市场题材情况而定）
              </p>
            </div>

            <div class="no-box">
              <div class="clearfix num-box no1">
                <div class="l-box">
                  <div class="num-title">题材研究手册</div>
                  <div class="text-box">
                    从产业链背景到上中下游逐级贯穿，网络关联公司，一站式深度梳理投资脉络，让题材研究不再跟风。
                  </div>
                </div>
                <div class="clearfix r-box">
                  <em class="img-box"></em>
                  <em class="img-box"></em>
                </div>
              </div>
              <div class="clearfix num-box no2">
                <div class="l-box">
                  <div class="num-title">题材挖掘五大策略</div>
                  <div class="text-box">
                    产业链关联公司丰富繁杂，如何抉择？题材王提供龙头潜力、资金动向、盘口弹性、盈利能力、综合评分等五维一体筛选模块。
                  </div>
                </div>
                <div class="clearfix r-box">
                  <ul class="t-list">
                    <li class="t-item">
                      近期领涨
                    </li>
                    <li class="t-item">
                      AI资金
                    </li>
                    <li class="t-item">
                      个股评分
                    </li>
                    <li class="t-item">
                      业绩增强
                    </li>
                    <li class="t-item">
                      短期活跃度
                    </li>
                  </ul>
                </div>
              </div>
              <div class="clearfix num-box no3">
                <div class="l-box">
                  <div class="num-title">产业链群四大服务（慧信）</div>
                  <div class="text-box">
                    提供产业链逻辑研究直播，产业链脱水研报，产业链公司机构调研，产业链政策动态发布。
                  </div>
                </div>
                <div class="clearfix r-box">
                  <em class="img-box"></em>
                  <em class="img-box"></em>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-box">
          <div class="c-box">
            <div class="title-black">
              <p>题材王功能入口</p>
              <p>
                下载大智慧APP---找到决策---体验题材王
              </p>
            </div>

            <div class="clearfix step-box">
              <span class="s-item">
                <p>第一步</p>
                <div class="img-box">

                </div>
                <div class="btm-text">
                  <p>扫描二维码</p>
                  <p>下载大智慧手机客户端</p>
                </div>
              </span>
              <span class="s-item">
                <p>第二步</p>
                <div class="img-box">

                </div>
              </span>
              <span class="s-item">
                <p>第三步</p>
                <div class="img-box">

                </div>
              </span>
            </div>
          </div>
        </div>
        <div class="panel-box">
          <div class="c-box">
            <div class="title-box  t3">
              大智慧策略投资终端明星功能展示
            </div>
            <div class="tle-tab-box">
              <ul class="tab-list">
                <li class="tab-item" v-for="(item,index) in tabtitles" :class="{active:tabSelectedIndex==index}" @click="tabSelectedIndex = index">
                  {{item}}
                </li>
              </ul>
            </div>
            <div class="tabresult-box">
              <div class="r-item" v-for="(item,index) in imgList" :class="{active:tabSelectedIndex==index}">
                  <img :src="item" />
              </div>
            </div>
          </div>
        </div>
        <div class="footer-box">
        	<div class="ctn-box">
        		<span class="c-f">活动须知：《大智慧365》、《大智慧专业版》、《大智慧财富版》、《大智慧策略投资终端》双年卡，季卡，月卡均不参与活动。</span>
        		<span class="r-f">股市有风险，投资需谨慎</span>
        	</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
	name: 'activity519',
  components: {
    AppHeader,
  },
  data () {
    return {
        token: '',
        tabtitles:[
          '个股评分','选股预警','全息盘口','ACE资金','大数据掘金'
        ],
        tabSelectedIndex:0,
        imgList:[
          require("@/assets/images/activity/activity519/listbg1.png"),
          require("@/assets/images/activity/activity519/listbg2.png"),
          require("@/assets/images/activity/activity519/listbg3.png"),
          require("@/assets/images/activity/activity519/listbg4.png"),
          require("@/assets/images/activity/activity519/listbg5.png")
        ]
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {


  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      // if (this.token && key !== 4024) {
      //   routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      // } else {
      //   routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      // }
      routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
a{
	text-decoration: none;
}
ul,li{
	list-style: none;
}
$url:'../../assets/images/activity/activity519/';
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
$color:#7c35ff;
body{

}

.activity519{

	.top-banner{
		width: 100%;
		height: 300px;
		background:#8e0d0f url($url+'banner.png')no-repeat center/1920px;
    margin-bottom: 150px;
	}
	.body-content{
		.ctn-box{
      .panel-box{
        .c-box{
          width: 1200px;
          margin: 0 auto;
          .title-box{
            font-size: 36px;
            color: #DD1818;
            text-align: center;
            padding-top: 193px;
            //height: 123px;
            padding-top: 43px;
            box-sizing: border-box;
            background: url($url+'titlebg1.png')no-repeat center top/1009px ;
            padding-bottom: 30px;
            &.t2{
              margin-bottom: 20px;
              background: url($url+'titlebg2.png')no-repeat center top/1189px ;
            }
            &.t3{
              margin-bottom: 20px;
              background: url($url+'titlebg3.png')no-repeat center top/1304px ;
            }
          }
          .tlebtm-bigfont{
            font-size: 40px;
            color: #DD1818;
            text-align: center;
            padding-bottom: 50px;
            span{
              position: relative;
              display: inline-block;
              &:before,&:after{
                content: '';
                position: absolute;
                width: 50px;
                height: 2px;
                background: #DD1818;
                top:27px;

              }
              &:before{
                left: -80px;
              }
              &:after{
                right: -80px;
              }
            }

          }
          .tle-tip{
            font-size: 24px;
            color: #555555;
            text-align: center;
          }
          .price-box{
            .p-item{
              display: inline-block;
              text-align: center;
              background-image: linear-gradient(135deg, rgba(255,126,95,0.10) 0%, rgba(254,180,123,0.10) 100%);
              border: 3px solid rgba(255,126,95,1);
              border-radius: 20px;
              box-sizing: border-box;
               float: left;
              .tle-box{
                font-size: 28px;
                color: #DD1818;
                line-height: 40px;
                text-align: center;
              }
              .p-box{
                font-size: 28px;
                color: #DD1818;
                 line-height: 40px;
                text-align: center;
                font-weight: bold;
                .p-em{
                  font-size: 20px;
                  display: inline-block;
                  padding-right: 4px;
                  vertical-align: bottom;
                }
              }
            }
            .symbol-box{
              float: left;
              width: 52px;
              font-size: 48px;
              color: #DD1818;
              text-align: center;
              display: inline-block;
              height: 142px;
              line-height: 142px;
            }
            &.formula-box{
              padding-top: 50px;
              .p-item{
                width: 361px;
                height: 142px;
                .tle-box{
                  padding-top: 21px;
                }
                .p-box{
                  padding-top: 20px;
                }
              }
              .btn-box{
                padding-top: 100px;
                padding-bottom: 150px;
              }
            }
            &.tw-box{
              padding-top: 50px;
              text-align: center;
              .tw-item{
                display: inline-block;
                width: 508px;
                margin-right: 92px;
                &:last-child{
                  margin-right: 0;
                }
              }
              .p-item{
                display: block;
                width: 100%;
                height: 193px;
                float: none;

                .tle-box{
                  padding-top: 50px;
                }
                .p-box{
                  padding-top: 13px;
                }
              }
              .btn-box{
                padding-top: 50px;
                padding-bottom: 100px;
                .buy-btn{
                  line-height: 70px;
                  cursor: pointer;
                  width: 192px;
                  height: 70px;
                }
              }
            }
          }
          .buy-btn{
            cursor: pointer;
            background-image: linear-gradient(180deg, #DD1818 0%, #ED213A 100%);
            box-shadow: 0px 2px 10px 0px rgba(178,6,0,0.5);
            border-radius: 20px;
            font-size: 28px;
            color: #F6FFA4;
            text-align: center;
            font-weight: bold;
            width: 258px;
            height: 80px;
            line-height: 80px;
            display: block;
            margin: 0 auto;
          }
          .btn-box{

          }
          .title-black{
            font-size: 30px;
            color: #222222;
            text-align: center;
            line-height: 42px;
            padding-bottom: 20px;
            font-weight: bold;
          }
          .no-box{
            padding-top: 80px;
            .num-box{
              position: relative;
              margin-bottom: 100px;
              display: flex;
              .l-box{
                display: inline-block;
                text-align: left;
                float: left;
                width: 370px;
                .num-title{
                  font-size: 30px;
                  color: #222222;
                  text-align: left;
                  padding-top: 78px;
                  line-height: 42px;
                }
                .text-box{
                  padding-top: 85px;
                  font-size: 24px;
                  color: #555555;
                  text-align: left;
                }
              }
              .r-box{
                display: inline-block;
                float: left;
                display: flex;
                .img-box{}
                .t-list{
                  display: block;
                  text-align: center;
                  width: 634px;
                  padding-left: 190px;
                  margin: 0 -27px;
                  .t-item{
                    font-size: 24px;
                    color: #DD1818;
                    text-align: center;
                    border: 2px solid rgba(221,24,24,1);
                    width: 150px;
                    height: 150px;
                    display: inline-block;
                    text-align: center;
                    margin:0 27px;
                    line-height: 148px;
                    border-radius: 150px;
                    &:nth-child(n+4){
                      margin-top: 50px;
                    }
                  }
                }
              }
              &.no1{
                margin-bottom: 90px;
                &:before{
                  content: '';
                  width: 50px;
                  height: 2px;
                  background: #DD1818;
                  position: absolute;
                  bottom: 10px;
                  left: 0;
                }
                .l-box{
                  width: 370px;
                  margin-right: 116px;
                  .num-title{
                    background: url($url+'n01.png')no-repeat left top/189px;
                  }
                }
                .r-box{
                  .img-box{
                    width: 307px;
                    height: 437px;
                    width: 327px;
                    height: 457px;
                    position: relative;
                    margin-top: -10px;
                    display: inline-block;
                    background:url($url+'no1img2.png')no-repeat center/100%;
                    &:first-child{
                      margin-right: 80px;
                      background:url($url+'no1img1.png')no-repeat center/100%;
                    }
                  }
                }
              }
              &.no2{
                .l-box{
                  .num-title{
                    background: url($url+'n02.png')no-repeat left top/189px;
                  }
                  .text-box{
                    padding-top: 111px;
                  }
                }
              }
              &.no3{
                margin-bottom: 89px;
                &:before{
                  content: '';
                  width: 50px;
                  height: 2px;
                  background: #DD1818;
                  position: absolute;
                  bottom: 11px;
                  left: 0;
                }
                .l-box{
                  .num-title{
                    background: url($url+'n03.png')no-repeat left top/189px;
                  }
                }
                .r-box{
                  padding-left: 115px;
                  .img-box{
                    width: 306px;
                    height: 661px;
                    background:url($url+'no3img2.png')no-repeat center/100%;
                    width: 328px;
                    height: 682px;
                    position: relative;
                    margin-top: -11px;
                    &:first-child{
                      margin-right: 81px;
                      background:url($url+'no3img1.png')no-repeat center/100%;
                    }
                  }
                }
              }
            }
          }
          .step-box{
            padding-top: 50px;
            padding-bottom: 150px;
            text-align: center;
            .s-item{
              display: inline-block;
              vertical-align: top;
              p{
                font-size: 30px;
                color: #222222;
                text-align: center;
                line-height: 42px;
              }
              .img-box{
                margin: 30px auto;
                height: 141px;
                img{
                  display: block;
                  margin: 0 auto;
                }
              }
              .btm-text{
                p{
                  font-size: 24px;
                  color: #222222;
                  text-align: center;
                  line-height: 33px;
                  padding-bottom: 10px;
                  &:last-child{
                    padding-bottom: 0;
                  }
                }
              }
              &:first-child{
                margin-right: 108px;
                .img-box{
                  width: 141px;
                  background: url($url+'vcode.png')no-repeat center/100%;
                }
              }
              &:nth-child(2){
                margin-right: 37px;
                .img-box{
                  background: url($url+'step1.png')no-repeat center/378px;
                }
              }
              &:nth-child(3){
                .img-box{
                  background: url($url+'step2.png')no-repeat center/378px;
                }
              }
              &:nth-child(2),&:nth-child(3){
                .img-box{
                  width: 378px;
                  height: 149px;
                }
              }
            }
          }

          .tle-tab-box{
            //padding-top: 50px;
            .tab-list{
              display: flex;
              .tab-item{
                max-width: 20%;
                display: inline-block;
                font-size: 28px;
                color: #222222;
                text-align: center;
                line-height: 40px;
                padding-bottom: 50px;
                margin-right: 148px;
                cursor: pointer;
                &:last-child{
                  margin-right: 0;
                }
                &.active{
                  color: #DD1818;
                  border-bottom: 3px solid #DD1818;
                }
              }
            }
          }
          .tabresult-box{
            padding-top: 50px;
            padding-bottom: 100px;
            .r-item{
              width: 1200px;
              height: 880px;
              display: none;
              img{
                width: 100%;
                border-radius: 20px;
              }
              &.active{
                display: block;
              }
            }
          }
        }
      }
      .footer-box{
        height: 130px;
        background: #DD1818;
         text-align: center;
        .ctn-box{
          padding-top: 30px;
          .c-f{
            font-size: 18px;
            color: #FCF2E0;
            display: block;
            text-align: center;
          }
          .r-f{
            padding-top: 20px;
            display: block;
            font-size: 18px;
            color: #FCF2E0;
            text-align: center;
          }
        }
      }
    }
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/activity/activity519.vue